import * as benefitStyle from '../styles/benefits.module.scss';
import * as featureProjectStyle from '../styles/featuredProject.module.scss';
import * as projectStyle from '../styles/pages/project.module.scss';
import * as cardStyle from '../styles/projects/project-card.module.scss';
import * as richtextStyle from '../styles/richtext.module.scss';
import * as timelineStyle from '../styles/timeline.module.scss';
class ClassUtils {
  static getFeaturedProjectBenefitClass = className => {
    switch (className) {
      case 'Trees':
        return featureProjectStyle.Trees;
      case 'Time':
        return featureProjectStyle.Time;
      case 'Money':
        return featureProjectStyle.Money;
      case 'Digitize':
        return featureProjectStyle.Digital;
      case 'Fuel':
        return featureProjectStyle.Fuel;
    }
    return '';
  };
  static getProjectBenefitClass = className => {
    switch (className) {
      case 'Trees':
        return projectStyle.Trees;
      case 'Time':
        return projectStyle.Time;
      case 'Money':
        return projectStyle.Money;
      case 'Digitize':
        return projectStyle.Digital;
      case 'Fuel':
        return projectStyle.Fuel;
    }
    return '';
  };

  static getCardBenefitClass = className => {
    switch (className) {
      case 'Trees':
        return cardStyle.iconTrees;
      case 'Time':
        return cardStyle.iconTime;
      case 'Money':
        return cardStyle.iconMoney;
      case 'Digitize':
        return cardStyle.iconDigital;
      case 'Fuel':
        return cardStyle.iconFuel;
    }
    return '';
  };
  static getRichTextColorClassName = color => {
    switch (color) {
      case 'Red':
        return richtextStyle.red;
      case 'Blue':
        return richtextStyle.blue;
      case 'Green':
        return richtextStyle.green;
    }
    return null;
  };

  static getBenefitClass = className => {
    switch (className) {
      case 'Trees':
        return benefitStyle.Trees;
      case 'Time':
        return benefitStyle.Time;
      case 'Money':
        return benefitStyle.Money;
      case 'Digitize':
        return benefitStyle.Digital;
      case 'Fuel':
        return benefitStyle.Fuel;
    }
    return '';
  };

  static getStatusClass = className => {
    switch (className) {
      case 'Planned':
        return timelineStyle.planned;
      case 'Ongoing':
        return timelineStyle.ongoing;
      case 'Completed':
        return timelineStyle.completed;
    }
    return '';
  };
}
export default ClassUtils;
